'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  button: {
    archive: 'Archive',
    cancel: 'Cancel',
    destroy: 'Delete',
    hide: 'Hide',
    login: 'Log in',
    show: 'Show'
  },
  contactInformation: {
    contactInfo: 'Contact Information',
    copyOrganizationInfo: "Copy organization's info",
    email: 'Email',
    name: 'Name',
    specifyProtocol: 'Always specify http:// or https:// .',
    telephone: 'Telephone',
    website: 'Website'
  },
  errors: {
    403: 'Permission denied.',
    405: 'Invalid request.',
    422: 'Certain fields are invalid. Please correct the missing or incorrect information and try again.',
    500: 'System error.'
  },
  eventsBox: {
    add: 'Add',
    events: 'Events',
    selectPlaceholder: 'Start typing to add an event'
  },
  form: {
    save: 'Save'
  },
  happiness: {
    help: 'Required fields',
    title: 'Happiness level'
  },
  imageBox: {
    credits: 'Photo credits',
    description: 'Description',
    image: 'Image',
    title: 'Title',
    uploadImageTypePngOrJpg: 'Please upload an image of format png or jpeg',
    uploadSmallerFile: 'Please upload an image of 8 mb or less'
  },
  loading: 'Loading...',
  mediaBox: {
    credits: 'Photo credits',
    description: 'Description',
    pleaseUploadSmallerFile: 'Please upload an image of 5 mb or less.',
    title: 'Title',
    uploadAnImage: 'Upload an image',
    uploadAnotherImage: 'Upload another image'
  },
  navigation: {
    account: 'Account',
    all_events: 'All events',
    calendars: 'Calendars',
    guide: 'User guide',
    logout: 'Logout',
    manage: 'Manage',
    notifications: 'Notifications',
    organizations: 'Organizations',
    taxonomies: 'Taxonomies',
    users: 'Users',
    venues: 'Venues'
  },
  oembed: {
    error: {
      501: 'Unsupported link'
    }
  },
  orderPick: {
    asc: 'ascending',
    desc: 'descending',
    orderBy: 'Order by'
  },
  organizationBox: {
    noneSelected: 'None selected',
    title: 'Organization'
  },
  pager: {
    next: 'Next',
    prev: 'Previous'
  },
  regionBox: {
    title: 'Region'
  },
  roles: {
    super_admin: 'Super-Administrator',
    admin: 'Administrator',
    editor: 'Editor',
    contributor: 'Contributor',
    guest: 'Guest',
    none: 'None'
  },
  scopeSelector: {
    all: 'All the context',
    calendars: 'Calendars',
    organizations: 'Organizations'
  },
  simpleSelect: {
    noResults: 'No results',
    select: 'Select...',
    typeSome: 'Type something to search...'
  },
  snackbar: {
    accountUpdated: 'Your account has been updated.',
    cantDestroyOrganization: 'Unable to delete the organization. Are you sure it is not linked to other organizations or calendars?',
    eventDestroyed: '%{title} deleted successfully',
    eventUnlinked: '%{title} removed from calendar %{calendar} successfully',
    notification: {
      archived: 'Notification archived.',
      destroyed: 'Notification deleted.'
    },
    organizationDestroyed: '%{title} deleted successfully',
    termDestroyed: '%{title} deleted successfully',
    userDestroyed: '%{name} deleted successfully',
    userUninvited: 'User access revoked.',
    venueDestroyed: '%{title} deleted successfully',
    undo: 'Undo'
  },
  userRoleSelector: {
    add: 'Add',
    addUser: 'Add user',
    as: 'as',
    help: 'Select the user and their role',
    hideInheritedRights: 'Hide the inherited rights',
    selectRole: 'Select role',
    selectUser: 'Select user',
    label: 'User roles',
    members: 'Members',
    on: 'on',
    role: 'Role',
    selectPlaceholder: 'Name or email address',
    showInheritedRights: 'Show the inherited rights',
    user: 'User'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/app.js
// module id = 2280
// module chunks = 0